import Vue from "vue";

Date.prototype.format = function (fmt) {
    let o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        S: this.getMilliseconds()
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
    return fmt;
};

Vue.filter("fmt-time", time => {
    if (!time) return "";
    return new Date(time).format("yyyy-MM-dd hh:mm");
});

Vue.filter("fmt-date", time => {
    return new Date(time).format("yyyy-MM-dd");
});

Vue.filter("fmt-car-type", time => {
    switch (time) {
        case "in":
            return "自有";
        case "out":
            return "外协";
    }
});

/**
 * //     if (item[1] == "太仓") area = "taicang";
            //     if (item[1] == "内蒙古") area = "neimenggu";
            //     if (item[1] == "广东") area = "guangdong";
            //     if (item[1] == "宁波") area = "ningbo";
            //     if (item[1] == "福建") area = "fujian";
            //     if (item[1] == "川渝") area = "chuanyu";
            //     if (item[1] == "陕西") area = "shanxixian";
            //     if (item[1] == "安徽") area = "anhui";
            //     if (item[1] == "河北") area = "hebei";
            //     if (item[1] == "鲁南") area = "lunan";
            //     if (item[1] == "鲁北") area = "lubei";
            //     if (item[1] == "山西") area = "shanxitaiyuan";
            //     if (item[1] == "湖南") area = "hunan";
            //     if (item[1] == "湖北") area = "hubei";
            //     if (item[1] == "河南") area = "henan";
            //     if (item[1] == "常州周边") area = "changzhou";
 */
Vue.filter("fmt-sh-area", time => {
    switch (time) {
        case "taicang":
            return "太仓";
        case "neimenggu":
            return "内蒙古";
        case "guangdong":
            return "广东";
        case "ningbo":
            return "宁波";
        case "fujian":
            return "福建";
        case "chuanyu":
            return "川渝";
        case "shanxixian":
            return "陕西";
        case "anhui":
            return "安徽";
        case "hebei":
            return "河北";
        case "lunan":
            return "鲁南";
        case "lubei":
            return "鲁北";
        case "shanxitaiyuan":
            return "山西";
        case "hunan":
            return "湖南";
        case "hubei":
            return "湖北";
        case "henan":
            return "河南";
        case "changzhou":
            return "常州周边";
        default:
            return time;
    }
});

Vue.filter("fmt-type", it => {
    switch (it) {
        case "xiaofei":
            return "消费";
        case "chongzhi":
            return "充值";
        case "zengsong":
            return "赠送";
        case "qita":
            return "其他";
    }
});

Vue.filter("fmt-car-row", time => {
    switch (time) {
        case "single":
            return "单排";
        case "double":
            return "双排";
    }
});

Vue.filter("fmt-car-dispatchtype", time => {
    switch (time) {
        case "short":
            return "短线";
        case "long":
            return "长线";
    }
});

Vue.filter("fmt-car-state", time => {
    switch (time) {
        case "normal":
            return "正常";
        case "repair":
            return "维修";
        case "inspection":
            return "年检";
    }
});

Vue.filter("fmt-cost-type", time => {
    switch (time) {
        case "reimburse":
            return "报销款";
        case "finance":
            return "财务款";
    }
});

Vue.filter("fmt-gender", time => {
    switch (time) {
        case 1:
            return "男";
        case 2:
            return "女";
        default:
            return "";
    }
});

Vue.filter("fmt-tofixed2", num => {
    return num.toFixed(2);
});

Vue.filter("fmt-massloss-typemassloss", time => {
    switch (time) {
        case "yiban":
            return "一般质损";
        case "qiandan":
            return "签单质损";
        case "tuiku":
            return "退库质损";
        case "maiduan":
            return "买断质损";
        case "gongsi":
            return "公司买断";
        case "zhongda":
            return "重大质损";
        case "teda":
            return "特大质损";
    }
});

Vue.filter("fmt-massloss-typeindemnity", time => {
    switch (time) {
        case "geren":
            return "个人承担";
        case "jingxiaoshang":
            return "经销商";
        case "baoxian":
            return "保险理赔";
        case "gongsi":
            return "公司承担";
    }
});

Vue.filter("fmt-massloss-duty", time => {
    switch (time) {
        case "person":
            return "驾驶员";
        case "company":
            return "公司";
        case "common":
            return "共同承担";
    }
});

Vue.filter("fmt-massloss-status", time => {
    switch (time) {
        case "wait":
            return "待处理";
        case "doing":
            return "处理中";
        case "did":
            return "已处理";
        case "finish":
            return "已结案";
    }
});

Vue.filter("fmt-massloss-typetransport", time => {
    switch (time) {
        case "highway":
            return "公路";
        case "waterway":
            return "水路";
    }
});

Vue.filter("fmt-supply-type", time => {
    switch (time) {
        case "diaodu":
            return "调度补款";
        case "zhisun":
            return "质损补款";
        case "fakuan":
            return "罚款补款";
        case "qita":
            return "其他补款";
    }
});

Vue.filter("fmt-unit", time => {
    switch (time) {
        case "tiao":
            return "条";
        case "fu":
            return "付";
        case "tao":
            return "套";
        case "pian":
            return "片";
        case "mi":
            return "米";
        case "zhi":
            return "只";
        case "sheng":
            return "升";
        case "tai":
            return "台";
        case "gen":
            return "根";
        case "ge":
            return "个";
        case "tong":
            return "桶";
    }
});

Vue.filter("fmt-materialtype", time => {
    switch (time) {
        case "jiyou":
            return "机油类";
        case "luntai":
            return "轮胎类";
        case "baoyang":
            return "保养类";
        case "peijian":
            return "配件类";
    }
});

Vue.filter("fmt-abs", time => {
    if (!time) return "";
    return Math.abs(time);
});
